import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import { canSetMarketingCookies } from './canSetMarketingCookies';

const TINUITI_COOKIE_NAME = 'at_tinuitifpc';
const EVENT_URL = 'https://pixel.pointmediatracker.com/kpi';
const TAG_ID = '302';
const CAMPAIGN_ID = 'alltrails';
const TINUITI_COOKIE_EXPIRATION_DAYS = 7;

enum TinuitiKpi {
  PageView = 'page_view',
  CompleteRegistration = 'complete_registration',
  Purchase = 'purchase'
}

export type EventData = {
  fpc?: string;
  user_id?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  order_value_usd?: string;
};

const trackTinuitiEvent = (kpi: TinuitiKpi, data: EventData) => {
  if (!data.fpc) {
    return;
  }

  const url = new URL(EVENT_URL);
  url.searchParams.append('c', CAMPAIGN_ID);
  url.searchParams.append('kpi', kpi);
  url.searchParams.append('tag_id', TAG_ID);
  url.searchParams.append('fpc', data.fpc);

  if (data.user_id) {
    url.searchParams.append('user_id', data.user_id);
  }
  if (data.utm_source) {
    url.searchParams.append('utm_source', data.utm_source);
  }
  if (data.utm_medium) {
    url.searchParams.append('utm_medium', data.utm_medium);
  }

  if (data.utm_campaign) {
    url.searchParams.append('utm_campaign', data.utm_campaign);
  }

  if (data.order_value_usd) {
    url.searchParams.append('order_value', data.order_value_usd);
  }

  // There's really nothing we can do if this fails, be it from adblockers
  // or from Tinuiti having issues.
  fetch(url.toString(), {
    method: 'GET',
    keepalive: true
  }).catch(() => null);
};

const trackTinuitiPageView = (userId?: string) => {
  const fpc = Cookies.get(TINUITI_COOKIE_NAME);
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  const eventData: EventData = {
    fpc,
    user_id: userId
  };

  if (utmSource) {
    eventData.utm_source = utmSource;
  }

  if (utmMedium) {
    eventData.utm_medium = utmMedium;
  }

  if (utmCampaign) {
    eventData.utm_campaign = utmCampaign;
  }

  trackTinuitiEvent(TinuitiKpi.PageView, eventData);
};

const handleTinuitiCookie = () => {
  if (canSetMarketingCookies(Cookies.get('at_osano'))) {
    const existingTinuitiCookie = Cookies.get(TINUITI_COOKIE_NAME);
    if (existingTinuitiCookie) {
      Cookies.set(TINUITI_COOKIE_NAME, existingTinuitiCookie, { expires: TINUITI_COOKIE_EXPIRATION_DAYS, domain: 'alltrails.com' });
    } else {
      const uuid4 = uuidv4();
      Cookies.set(TINUITI_COOKIE_NAME, uuid4, { expires: TINUITI_COOKIE_EXPIRATION_DAYS, domain: 'alltrails.com' });
    }
  } else {
    Cookies.remove(TINUITI_COOKIE_NAME);
  }
};

const trackTinuitiPurchase = (orderValue: string, userId?: string) => {
  const fpc = Cookies.get(TINUITI_COOKIE_NAME);
  trackTinuitiEvent(TinuitiKpi.Purchase, {
    fpc,
    user_id: userId,
    order_value_usd: orderValue
  });
};

const trackTinuitiRegistration = (userId?: string) => {
  const fpc = Cookies.get(TINUITI_COOKIE_NAME);
  trackTinuitiEvent(TinuitiKpi.CompleteRegistration, {
    fpc,
    user_id: userId
  });
};

export { trackTinuitiPurchase, trackTinuitiPageView, trackTinuitiRegistration, handleTinuitiCookie };
